import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useActions } from '../../store'
import { useAuth } from '../index'

const { env } = window

const useTenants = (enabled = true) => {
  const { loggedIn, securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { progressStart, progressEnd } = useActions()

  const getTenants = async () => {
    const fetchFn = loggedIn ? securedFetch : fetch
    const url = encodeURI(
      loggedIn ? `${env.apiUrl}/userTenants` : `${env.publicApiUrl}/tenants`
    )
    const response = await fetchFn(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['tenants', loggedIn],
    queryFn: getTenants,
    enabled
  })

  useEffect(() => {
    if (query.isLoading) {
      progressStart()
    } else if (query.isSuccess) {
      progressEnd()
    } else if (query.isError) {
      handleError(query.error, 'Error getting stories')
      progressEnd()
    }
  }, [
    query.isLoading,
    query.isSuccess,
    query.isError,
    query.error,
    progressStart,
    progressEnd,
    handleError
  ])

  return {
    tenants: query.data
  }
}

export { useTenants }
